export default "__VITE_ASSET__2e3d3847__"